import BaseUseCase from "../../../base_use_case.js";

class NewProjectUseCase extends BaseUseCase {

  execute() {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/projects/projects/new`,
    });
  }
}

const instance = new NewProjectUseCase();
export default instance;